import HttpService from './HttpService';

export default class TransactionService extends HttpService {
    endPoint = "/v1/payments"

    refundPayment(identifier, data) {
        return new HttpService().getAuthTokenRequest()
            .patch("/v1/payments/" + identifier + "/refund-capture", data);
    }
}
